var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cf-toolbar"},[_c('p',{staticClass:"cf-toolbar-desc"},[_vm._v(_vm._s(_vm.$t('admin.companies.subtitle')))]),_c('router-link',{staticClass:"cf-btn-create",attrs:{"to":"/admin/companies/create"}},[_c('i',{staticClass:"fal fa-plus"}),_c('span',[_vm._v(_vm._s(_vm.$t('companies.create_company')))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }